module.exports = "https://cdn.realtymogul.com/static/media/img_leftpanel.28aa1f4f.jpg";